import React, {useEffect, useState} from 'react'
import {getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'
import {DatePickerMonthComponent} from "../../ui/DatePickerMountComponent";

export const ProfileExperienceForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [workingExperienceCatalog, setWorkingExperienceCatalog] = useState([])
    const [municipalities, setMunicipalities] = useState([])
    const [countries, setCountries] = useState([])

    const [showCompanyError, setShowCompanyError] = useState(false)
    const [showPositionError, setShowPositionError] = useState(false)
    const [showStartingDateError, setShowStartingDateError] = useState(false)
    const [showEndingDateError, setShowEndingDateError] = useState(false)
    const [backError, setBackError] = useState('');

    useEffect (() => {
        getResource('working_experience_catalog').then((data) => {
            console.log(`working_experience_catalog`)
            console.log(data.data)
            setWorkingExperienceCatalog(data.data)
        })
        getResource('municipalities/get_active').then((data) => {
            console.log(data.data)
            setMunicipalities(data.data)
        })
        getResource('countries/get_active').then((data) => {
            console.log(data.data)
            setCountries(data.data)
        })
        setEntity(entityTemp);
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-12 d-flex justify-content-around flex-wrap">
                                <div className="col-lg-7 col-12">
                                    {(workingExperienceCatalog && workingExperienceCatalog.length > 0) &&
                                        (<>
                                            <Combo
                                                tooltipText="Одберете област на работно искуство"
                                                comboClass="combo-form"
                                                placeholder="Област на работно искуство"
                                                entity={(entity.workingExperienceCatalog) && entity.workingExperienceCatalog.name}
                                                onChange={(e) => {
                                                    setShowCompanyError(true)
                                                    setShowPositionError(false)
                                                    let chosenWorkingExperienceCatalog = {};
                                                    chosenWorkingExperienceCatalog.id = e.target.value;
                                                    setEntity({ ...entity, workingExperienceCatalog: chosenWorkingExperienceCatalog})
                                                }}
                                                onClear={() => setEntity({...entity, workingExperienceCatalog: null})}
                                                array={workingExperienceCatalog}/>
                                            </>
                                        )}
                                    <input className="input-form w-100" type="text" required={true} placeholder="Компанија"
                                           value={entity.company}
                                           onChange={(e) => {
                                               setEntity({...entity, company: e.target.value})
                                               setShowCompanyError(false)
                                           }}
                                    />  {showCompanyError && <b>Ве молиме внесете го името на компанијата</b>}
                                    <input className="input-form w-100 mt-3" type="link" required={true} placeholder="Веб адреса на компанијата"
                                           value={entity.companyUrl}
                                           onChange={(e) => {
                                               setEntity({...entity, companyUrl: e.target.value})
                                           }}
                                    />
                                    {(municipalities && municipalities.length > 0) &&
                                        (
                                            <>
                                                <Combo
                                                    tooltipText="Општина во која се наоѓа компанијата"
                                                    comboClass="combo-form"
                                                    placeholder="Општина"
                                                    entity={(entity.place) && entity.place.name}
                                                    onChange={(e) => {
                                                        let chosenMunicipalities = {};
                                                        chosenMunicipalities.id = e.target.value;
                                                        setEntity({ ...entity, place: chosenMunicipalities })
                                                    }}
                                                    onClear={() => setEntity({...entity, place:null})}
                                                    array={municipalities}/></>)}

                                    {(countries && countries.length > 0) &&
                                        (
                                            <>
                                                <Combo
                                                    tooltipText="Држава во која се наоѓа компанијата"
                                                    comboClass="combo-form"
                                                    placeholder="Држава"
                                                    entity={(entity.country) && entity.country.name}
                                                    onChange={(e) => {
                                                        let chosenCountry = {};
                                                        chosenCountry.id = e.target.value;
                                                        setEntity({ ...entity, country: chosenCountry })
                                                    }}
                                                    onClear={() => setEntity({...entity, country:null})}
                                                    array={countries}/></>)}



                                    <input className="input-form w-100 my-3" type="text" required={true} placeholder="Работна позиција"
                                           value={entity.workingPosition}
                                           onChange={(e) => {
                                               setEntity({...entity, workingPosition: e.target.value})
                                               setShowPositionError(false)
                                           }}
                                    />
                                    {showPositionError && <b>Ве молиме внесете го името на работната позиција</b>}
                                </div>

                                <div className="col-lg-4 col-12">
                                       <DatePickerMonthComponent
                                           selectedDate={entity.dateFrom}
                                           onChange={(e)=> {
                                               setEntity({...entity, dateFrom:e})
                                               setShowStartingDateError(false)
                                           }}
                                           placeholder="месец/година на почеток"/>
                                    {showStartingDateError && <b>Ве молиме внесете месец и година на почеток</b>}

                                    <DatePickerMonthComponent
                                        selectedDate={entity.dateTo}
                                        onChange={(e)=> {
                                            setEntity({...entity, dateTo:e})
                                            setShowEndingDateError(false)
                                        }}
                                        placeholder="месец/година на крај"/>
                                    {showEndingDateError && <b>Ве молиме внесете месец и година на крај</b>}
                                  <div className="col-6 d-flex justify-content-around align-items-center">
                                      <input type="checkbox"
                                             id="forWorkExperience"
                                             name="forWorkExperience" value={entity.currentEmployment}
                                             checked={entity.currentEmployment}
                                             onClick={(e) =>
                                                 setEntity({...entity, currentEmployment: !entity.currentEmployment})}/>
                                      <label className="lightBlue" htmlFor="forWorkExperience">Сеуште</label>
                                  </div>

                                    <div className="profile-form-edit">
                                        <p className="lightBlue w-100">Одговорности на работно место</p>
                                          <textarea className="input-form w-100" type="text" required={true} placeholder=""
                                                    value={entity.responsibilities}
                                                    onChange={(e) => setEntity({...entity, responsibilities: e.target.value})}
                                          />
                                    </div>
                                </div>


                            {backError && <b>{backError}</b>}
                            <div className="col-12 d-flex justify-content-around flex-wrap">
                                <div
                                    className="btn-form"
                                    onClick={()=>
                                    {setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори</div>
                                <div
                                    className="btn-form"
                                    onClick={(e) => {
                                        if((entity.workingExperienceCatalog && entity.workingExperienceCatalog.id !== "") &&
                                            (!entity.company || entity.company === "")) {
                                            setShowCompanyError(true)
                                        }else if(!entity.workingPosition || entity.workingPosition === "") {
                                            setShowPositionError(true)
                                        } else if (!entity.dateFrom || entity.dateFrom === "") {
                                            setShowStartingDateError(true)
                                        } else if (!entity.currentEmployment && (!entity.dateTo || entity.dateTo === "")) {
                                            setShowEndingDateError(true)
                                        } else {
                                            updateResource('candidates_experience', entity)
                                                .then((data) => {
                                                    console.log(data.data)
                                                    setAddEntity(false)
                                                    setEntityTemp({candidate: entity.candidate})
                                                    setUpdateEntity(!updateEntity)
                                                }).catch((exception) => {
                                                setBackError(exception.response.data.message);
                                            })
                                        }
                                    }}
                                >Зачувај</div>
                            </div>
                        </div>
            </>
            )
                }
        </div>
    )
}